import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { stats } from '@/mocks/comics';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      <Navbar />
      <main>
        {/* Breadcrumb */}
        <div className="pt-20 pb-0 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 py-3" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-s-line"></i>
              </div>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Hero */}
        <section className="relative h-[240px] md:h-[300px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20background%20with%20soft%20gradient%20of%20coral%20and%20warm%20beige%20tones%2C%20minimalist%20composition%2C%20gentle%20atmospheric%20lighting%2C%20clean%20modern%20aesthetic%2C%20subtle%20texture%2C%20no%20text&width=1920&height=600&seq=about-banner&orientation=landscape"
            alt="关于我们"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-2xl md:text-3xl font-heading text-white mb-2">关于虫虫动漫</h1>
            <p className="text-sm text-white/75">致力于为漫画爱好者提供最佳的在线阅读体验</p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6 text-center">品牌介绍</h2>
            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                虫虫动漫成立于2024年，是一个专注于提供<strong>韩漫、日漫、国漫</strong>免费在线阅读的平台。我们深知每一位漫画爱好者对优质内容的需求，因此我们精心筛选了涵盖恋爱、奇幻、热血、校园、仙侠等多种题材的漫画作品，力求为用户提供最丰富的阅读选择。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                我们的核心理念是让每一位读者都能享受到<strong>流畅舒适的下拉式阅读体验</strong>。不同于传统翻页模式，虫虫动漫采用优化的下拉式滚动浏览方式，让阅读更加自然连贯，减少等待时间，提升沉浸感。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                平台持续更新热门漫画资源，确保用户能够及时追更最新章节。无论是韩漫的细腻画风、日漫的热血剧情还是国漫的独特韵味，虫虫动漫都致力于为您呈现最好的漫画阅读体验。
              </p>
            </div>
          </div>
        </section>

        {/* Our Reputation */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-8 text-center">读者口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-50 rounded-lg p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-heart-line text-2xl text-primary-500"></i>
                </div>
                <div className="text-3xl font-heading text-primary-500 mb-2">10,000+</div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-2">漫画资源</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">涵盖三大品类，持续更新中</p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-group-line text-2xl text-accent-500"></i>
                </div>
                <div className="text-3xl font-heading text-accent-500 mb-2">500万+</div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-2">月活跃读者</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">千万读者的共同选择</p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-thumb-up-line text-2xl text-secondary-500"></i>
                </div>
                <div className="text-3xl font-heading text-secondary-500 mb-2">99.9%</div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-2">好评率</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">优质体验赢得信赖</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-8 text-center">联系我们</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-background-100 rounded-lg p-6 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-lg text-primary-500"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h4>
                  <p className="text-sm text-foreground-600">contact@chongchongmanhua.com</p>
                  <p className="text-xs text-foreground-400 mt-1">商务合作 / 建议反馈</p>
                </div>
              </div>
              <div className="bg-background-100 rounded-lg p-6 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-customer-service-2-line text-lg text-accent-500"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">在线客服</h4>
                  <p className="text-sm text-foreground-600">工作日 9:00 - 18:00</p>
                  <p className="text-xs text-foreground-400 mt-1">版权问题 / 内容投诉</p>
                </div>
              </div>
              <div className="bg-background-100 rounded-lg p-6 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-notification-3-line text-lg text-secondary-500"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">版权声明</h4>
                  <p className="text-sm text-foreground-600">虫虫动漫严格遵守版权法规</p>
                  <p className="text-xs text-foreground-400 mt-1">如涉及侵权请联系我们处理</p>
                </div>
              </div>
              <div className="bg-background-100 rounded-lg p-6 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-question-line text-lg text-primary-500"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">常见问题</h4>
                  <p className="text-sm text-foreground-600">查看使用帮助和常见问题解答</p>
                  <p className="text-xs text-foreground-400 mt-1">快速解决您的疑问</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-8 text-center">常见问题</h2>
            <div className="space-y-4">
              <details className="bg-background-50 rounded-lg p-5 group cursor-pointer">
                <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between">
                  虫虫动漫上的漫画都是免费的吗？
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-2 transition-transform duration-200 group-open:rotate-180">
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </summary>
                <p className="text-sm text-foreground-600 mt-3 leading-relaxed">是的，虫虫动漫平台上的所有漫画资源均免费在线阅读，无需注册付费，让每一位漫画爱好者都能享受阅读乐趣。</p>
              </details>
              <details className="bg-background-50 rounded-lg p-5 group cursor-pointer">
                <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between">
                  下拉式阅读是什么意思？
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-2 transition-transform duration-200 group-open:rotate-180">
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </summary>
                <p className="text-sm text-foreground-600 mt-3 leading-relaxed">下拉式阅读是一种优化的漫画浏览方式，您只需向下滚动页面即可连续阅读，无需点击翻页按钮，阅读体验更加流畅自然，特别适合手机端阅读。</p>
              </details>
              <details className="bg-background-50 rounded-lg p-5 group cursor-pointer">
                <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between">
                  漫画多久更新一次？
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-2 transition-transform duration-200 group-open:rotate-180">
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </summary>
                <p className="text-sm text-foreground-600 mt-3 leading-relaxed">虫虫动漫会及时同步漫画的官方更新进度，大部分热门漫画保持每周更新，部分作品可能会有日更或双周更的频率。您可以关注喜欢的漫画获取最新更新通知。</p>
              </details>
              <details className="bg-background-50 rounded-lg p-5 group cursor-pointer">
                <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between">
                  如何找到我想看的漫画？
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-2 transition-transform duration-200 group-open:rotate-180">
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </summary>
                <p className="text-sm text-foreground-600 mt-3 leading-relaxed">您可以通过首页的搜索栏直接搜索漫画名称，也可以通过韩漫、日漫、国漫分类浏览，或者查看热门推荐和最新更新列表来发现感兴趣的漫画作品。</p>
              </details>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}